import axios from "axios";
import jsCookie from "js-cookie";
import { globalEventEmitter, GlobalEvents } from "./GlobalEventEmitter";

const axiosInstance = (isSecured?: boolean) => {
  let instance;

  if (!isSecured) {
    instance = axios.create({
      baseURL: import.meta.env.VITE_BASE_API_URL,
      headers: {
        Accept: "application/json",
        "X-Client-App": "educator-webapp",
      },
    });
  } else {
    const user = jsCookie.get("AUTHENTICATION_USER");
    const authenticationToken = jsCookie.get("AUTHENTICATION_TOKEN");
    const email = user ? JSON.parse(user).email : "";

    instance = axios.create({
      baseURL: import.meta.env.VITE_BASE_API_URL,
      headers: {
        "X-User-Email": email,
        "X-User-Token": authenticationToken,
        "X-Client-App": "educator-webapp",
        Accept: "application/json",
      },
    });
  }

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        globalEventEmitter.emit(GlobalEvents.API_REQUEST_UNAUTHORIZED);
      }

      throw error;
    },
  );

  return instance;
};

export const axiosInstances = Object.freeze({
  public: () => axiosInstance(),
  secured: () => axiosInstance(true),
});
